import React from 'react';
import PropTypes from 'prop-types';
import { Button, Plus, Select } from '@opendate-app/setlist';

const chartOptions = (events) => events.map(ev => ({
  value: String(ev.id),
  label: `${ev.context ? (ev.context === 'admission' ? 'Admission: ' : 'Add-on: ') : ''}${ev.seating_chart_name || `Chart #${ev.seating_chart_id}`}`
}));

const KillsHeader = ({ events, selectedEvent, onSelectEvent, onClickAdd, subtitle, addDisabled }) => (
  <div className="my-3 d-flex flex-column flex-md-row justify-content-between align-items-md-start" style={{ gap: 12 }}>
    <div>
      <div style={{ fontSize: '18px', fontWeight: 600, color: 'var(--sl-text-primary)' }}>Kills</div>
      <div style={{ fontSize: '14px', color: 'var(--sl-text-tertiary)' }}>{subtitle || 'Create and manage kills for this event.'}</div>
    </div>
    <div className="d-flex flex-column flex-md-row align-items-md-center" style={{ gap: 12 }}>
      {events.length > 0 ? (
      <div style={{ minWidth: 220 }}>
        <Select
          size="sm"
          aria-label="Seating chart"
          options={chartOptions(events)}
          value={selectedEvent ? String(selectedEvent.id) : ''}
          onChange={(value) => onSelectEvent(value)}
        />
      </div>
      ) : null}
      <Button icon={Plus} onClick={onClickAdd} disabled={Boolean(addDisabled)}>Add Kills</Button>
    </div>
  </div>
);

KillsHeader.propTypes = {
  events: PropTypes.array.isRequired,
  selectedEvent: PropTypes.object,
  onSelectEvent: PropTypes.func.isRequired,
  onClickAdd: PropTypes.func.isRequired,
  subtitle: PropTypes.string,
  addDisabled: PropTypes.bool
};

export default KillsHeader;
